import { render, staticRenderFns } from "./ProductViewInformation.vue?vue&type=template&id=4fe43678&"
import script from "./ProductViewInformation.vue?vue&type=script&lang=js&"
export * from "./ProductViewInformation.vue?vue&type=script&lang=js&"
import style0 from "./ProductViewInformation.vue?vue&type=style&index=0&id=4fe43678&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports